import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Agent avatar — BillPortal brand gradient circle (violet → fuchsia → pink)
 * with the agent's first initial + a subtle white AI sparkle in the
 * top-right corner. Used in the drawer header AND chat bubbles so the icon
 * stays consistent everywhere.
 *
 * Props:
 *   name   — agent display name; we render the first letter
 *   size   — pixel size of the circle (default 32)
 *   pulse  — adds the global `ai-agent-pulse` animation
 */
export const AgentSparkleAvatar = ({ name = 'Astrid', size = 32, pulse = false }) => {
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';
  // Scale the sparkle and ring proportionally to the avatar size.
  const sparkleSize = Math.max(10, Math.round(size * 0.42));
  const ringWidth = size <= 30 ? 2 : 2;
  return (
    <div
      data-testid="ai-agent-sparkle-avatar"
      className={`relative inline-flex shrink-0 items-center justify-center rounded-full select-none ${pulse ? 'ai-agent-pulse' : ''}`}
      style={{
        width: size,
        height: size,
        background: 'linear-gradient(135deg, #8b5cf6 0%, #d946ef 55%, #ec4899 100%)',
        boxShadow: `0 4px 10px rgba(139, 92, 246, 0.30), 0 0 0 ${ringWidth}px #fff`,
      }}
      aria-label={`Agent avatar — ${name}`}
    >
      <span
        style={{
          color: '#fff',
          fontWeight: 800,
          fontSize: Math.round(size * 0.46),
          letterSpacing: '-0.02em',
          lineHeight: 1,
          textShadow: '0 1px 1px rgba(0,0,0,0.18)',
        }}
      >
        {initial}
      </span>
      {/* White AI sparkle — subtle, top-right corner */}
      <Sparkles
        className="absolute"
        style={{
          top: -Math.round(size * 0.10),
          right: -Math.round(size * 0.10),
          width: sparkleSize,
          height: sparkleSize,
          color: '#ffffff',
          filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.20))',
        }}
        strokeWidth={2.5}
      />
    </div>
  );
};

export default AgentSparkleAvatar;
